import React from 'react'
import { withTranslation } from 'react-i18next'
import { useQuery, gql } from '@apollo/client'
import { Grid } from '@mui/material'
import Header from '../components/Headers/Header'
import { getConfiguration } from '../apollo'
import ReferralConfiguration from '../components/Configuration/Referral/Referral'

const GET_CONFIGURATION = gql`
  ${getConfiguration}
`

const Referral = props => {
  const { t } = props
  const { data, error: errorQuery, loading: loadingQuery } = useQuery(
    GET_CONFIGURATION
  )

  return (
    <>
      <Header />
      {errorQuery && t('Error')}
      {loadingQuery ? (
        t('LoadingDots')
      ) : (
        <Grid container ml={2} spacing={2}>
          <Grid item xs={12} md={12} lg={6}>
            <ReferralConfiguration
              referralEnabled={data && data.configuration.referralEnabled}
              referralCredits={data && data.configuration.referralCredits}
              creditsPerPound={data && data.configuration.creditsPerPound}
              currencySymbol={data && data.configuration.currencySymbol}
            />
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default withTranslation()(Referral)
